import LockIcon from "assets/icons/glory/lock_three_points.svg?react";

import "./styles.sass";
import classNames from "classnames";
import useTranslate from "../../../hooks/useTranslate";

type LoyaltyAvatarListItemProps = {
  id: string;
  avatar: string;
  selected: boolean;
  locked?: boolean;
  onClick: (mascotId: string) => void;
};

const LoyaltyAvatarListItem = (props: LoyaltyAvatarListItemProps) => {
  const { id, avatar, selected, locked, onClick } = props;
  const t = useTranslate();

  const handleClick = () => {
    if (!locked) {
      onClick(id);
    }
  };

  const classNameRoot = classNames(
    "LoyaltyAvatarListItem",
    selected && "LoyaltyAvatarListItem_selected",
  );

  return (
    <div className={classNameRoot} onClick={handleClick}>
      <div className="LoyaltyAvatarListItem__img">
        <img src={avatar} alt="avatar" />
      </div>

      {locked && (
        <div className="LoyaltyAvatarListItem__locked">
          <LockIcon />
        </div>
      )}
      {selected && (
        <div className="LoyaltyAvatarListItem__selected">
          {t("loyalty.avatar.inner.selected")}
        </div>
      )}
    </div>
  );
};

export default LoyaltyAvatarListItem;
